/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "aWzlQ2N6qqg",
    title:
      "Marvel Studios' Doctor Strange in the Multiverse of Madness | Official Trailer",
    img: "https://i.ytimg.com/vi/aWzlQ2N6qqg/maxresdefault.jpg",
    category: "Marvel",
    desc: "In Marvel Studios Doctor Strange in the Multiverse of Madness, the MCU unlocks the Multiverse and pushes its boundaries further than ever before. Journey into the unknown with Doctor Strange, who, with the help of mystical allies both old and new, traverses the mind-bending and dangerous alternate realities of the Multiverse to confront a mysterious new adversary.",
  },
  {
    _id: "AT3fCgxEAJE",
    title: "How Tutankhamun Got His Gold | Lost Treasures of Egypt",
    img: "https://i.ytimg.com/vi/AT3fCgxEAJE/maxresdefault.jpg",
    category: "Nat Geo",
    desc: "An immersive, action-packed and discovery-led series following International teams of Egyptologists as they unearth the world's richest seam of ancient archaeology - Egypt's Valley of the Kings. For a full season of excavations and with unprecedented access to the teams on the front line of archaeology, we follow these modern-day explorers as they battle searing heat and inhospitable terrain to make the discoveries of a lifetime.",
  },
  {
    _id: "uwEf0JKIFOc",
    title: "The Quest | Teaser Trailer | Disney+",
    img: "https://i.ytimg.com/vi/uwEf0JKIFOc/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLBfogWcJ-0_-Ms8YB7zp2fIAuQUgA",
    category: "Disney",
    desc: "Disney+ is the streaming home of Disney, Pixar, Marvel, Star Wars, National Geographic, and more. From new releases to your favorite classics and exclusive Originals, there's something for everyone, all ad free.  ",
  },
  {
    _id: "AZS5cgybKcI",
    title: "Kitbull | Pixar SparkShorts",
    img: "https://i.ytimg.com/vi/AZS5cgybKcI/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDiKKS_5bFwg2IHa6T_BGMN_n3vgw",
    category: "Pixar",
    desc: "Kitbull, directed by Rosana Sullivan and produced by Kathryn Hendrickson, reveals an unlikely connection that sparks between two creatures: a fiercely independent stray kitten and a pit bull. Together, they experience friendship for the first time. ",
  },
  {
    _id: "crABxPcIzCU",
    title: "Reign | The Book of Boba Fett | Disney+",
    img: "https://i.ytimg.com/vi/crABxPcIzCU/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLAmVQyhN4Ie3fVVTjP-PnPwnESH1A",
    category: "Star Wars",
    desc: "“The Book of Boba Fett,” a thrilling Star Wars adventure teased in a surprise end-credit sequence following the Season 2 finale of “The Mandalorian,” finds legendary bounty hunter Boba Fett and mercenary Fennec Shand navigating the galaxy’s underworld when they return to the sands of Tatooine to stake their claim on the territory once ruled by Jabba the Hutt and his crime syndicate.",
  },
  {
    _id: "i5qOzqD9Rms",
    title: "Incredibles 2 Official Trailer",
    img: "https://i.ytimg.com/vi/i5qOzqD9Rms/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLBFx-sisPCCtn1njCD_wVv1qUJ9Iw",
    category: "Pixar",
    desc: "In “Incredibles 2,” Helen (voice of Holly Hunter) is called on to lead a campaign to bring Supers back, while Bob (voice of Craig T. Nelson) navigates the day-to-day heroics of “normal” life at home with Violet (voice of Sarah Vowell), Dash (voice of Huck Milner) and baby Jack-Jack—whose super powers are about to be discovered. Their mission is derailed, however, when a new villain emerges with a brilliant and dangerous plot that threatens everything.",
  },
  {
    _id: "dXtA_xYVhUU",
    title: "Star Wars The Clone Wars Trailer",
    img: "https://i.ytimg.com/vi/dXtA_xYVhUU/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLC7zG2yT232kK1kF5A8NezFeqajeA",
    category: "Star Wars",
    desc: "Take a look back at the Celebration 2019 exclusive trailer for the final season of Star Wars: The Clone Wars.",
  },
  {
    _id: "lcYPrMk12zw",
    title: "Baymax! | Official Trailer | Disney+",
    img: "https://i.ytimg.com/vi/lcYPrMk12zw/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLABtT1f8Z6EscRVWyeSjL2fg5ix_A",
    category: "Disney",
    desc: "Check in with everyone’s favorite healthcare companion in a trailer for his new Disney+ Original Series. “Baymax,” Walt Disney Animation Studios’ first-ever animated series, starts streaming exclusively on Disney+ in Summer 2022.",
  },
  {
    _id: "A4-G7YpSFb4",
    title: "Smash and Grab | Pixar SparkShorts",
    img: "https://i.ytimg.com/vi/A4-G7YpSFb4/maxresdefault.jpg",
    category: "Pixar",
    desc: "Story of Two antiquated robots who risk everything for freedom and for each other after years of toiling away inside the engine room of a towering locomotive.",
  },
  {
    _id: "1f_YvciYqyQ",
    title: "Dispatches from the Halcyon: The Story",
    img: "https://i.ytimg.com/vi/1f_YvciYqyQ/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLCuQ35Ko-2187XhaKuvnIyXAM5yAw",
    category: "Star Wars",
    desc: "Step into Star Wars: Galactic Starcruiser! In this episode, we take you aboard the Halcyon starcruiser with a behind-the-scenes overview of the story inside the immersive entertainment experience now open at Walt Disney World Resort. Choose your destiny and live out your own Star Wars story.",
  },
  {
    _id: "DpZ3yZhsWZE",
    title: "Black Beauty | Official Trailer | Disney+",
    img: "https://i.ytimg.com/vi/DpZ3yZhsWZE/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLCB9jwdqoNYrG-jG_eFb72OBRIYAQ",
    category: "Disney",
    desc: "Find your way home. Black Beauty, starring Mackenzie Foy and featuring Academy Award-winner Kate Winslet as the voice of Beauty, premieres Nov. 27 on Disney Plus.",
  },
  {
    _id: "CIWKX3eWTKU",
    title: "The Most Powerful Artifacts in the Marvel Universe!",
    img: "https://i.ytimg.com/vi/CIWKX3eWTKU/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDcW8RUw7iq5pbwKvzwuZPs75yUFg",
    category: "Marvel",
    desc: "Step into the Marvel Universe each Wednesday with Marvel PLAY as we bring the comics to life with unique content including character profiles, behind-the-scenes clips, cosplay tips, trailers and more!",
  },
  {
    _id: "lle0NNmvIyU",
    title: "Star Wars: Visions | Original Trailer | Disney+",
    img: "https://i.ytimg.com/vi/lle0NNmvIyU/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLBN90Kcg3U5iIFg7rh-eMlvqJG8cQ",
    category: "Star Wars",
    desc: "Reimagine the galaxy with Star wars visions, an Original series featuring stories from seven visionary Japanese anime studios, streaming September 22.",
  },
  {
    _id: "hJZ82pwwJqA",
    title: "Jungle Cruise | Official Trailer ",
    img: "https://i.ytimg.com/vi/hJZ82pwwJqA/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLA5uciIZT9Y26z6YsUk3RV0e98QDA",
    category: "Disney",
    desc: "Inspired by the famous Disneyland theme park ride, Disney’s “Jungle Cruise” is an adventure-filled, rollicking thrill-ride down the Amazon with wisecracking skipper Frank Wolff and intrepid researcher Dr. Lily Houghton.",
  },
  {
    _id: "b9Gr9gKFxpE",
    title: "STAR WARS: VISIONS | SPECIAL LOOK | DISNEY+",
    img: "https://i.ytimg.com/vi/b9Gr9gKFxpE/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLBiV1agcZw3Bl8eG4HwXwsdm5WXLg",
    category: "Star Wars",
    desc: "Seven Japanese anime studios bring their unique talent and perspective to Star Wars: Visions, a collection of animated Original Short Films, streaming September 22 on Disney+.The anime studios revealed were Kamikaze Douga, Geno Studio (Twin Engine), Studio Colorido (Twin Engine), Trigger, Kinema Citrus, Science Saru, and Production IG. Each studio will use their signature animation and storytelling styles to realize their own visions of the galaxy far, far away.",
  },
  {
    _id: "gn5QmllRCn4",
    title: "Onward | Official Trailer",
    img: "https://i.ytimg.com/vi/gn5QmllRCn4/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDM-ncBj6mM6fbLlCp8WBPceMYZOg",
    category: "Pixar",
    desc: "Set in a suburban fantasy world, Disney and Pixars “Onward” introduces two teenage elf brothers who embark on an extraordinary quest to discover if there is still a little magic left out there. Pixar Animation Studios all-new original feature film is directed by Dan Scanlon and produced by Kori Rae—the team behind Monsters University. Onward releases in theaters on March 6, 2020.",
  },
  {
    _id: "1yBwWLunlOM&list=PLivjPDlt6ApRpidjp1zjROOCKru-89Q1_",
    title: "Rockets 101 | National Geographic",
    img: "https://i.ytimg.com/vi/1yBwWLunlOM/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDtdWkaYVCX__l3ic2pVe-vcx5wAA",
    category: "Nat Geo",
    desc: "Launching a rocket into space is one of humankind's crowning achievements. Learn about how rockets work, what happens during a launch, and how centuries of innovation made space exploration possible.",
  },
  {
    _id: "6ZfuNTqbHE8",
    title: "Marvel Studios Avengers: Infinity War Official Trailer",
    img: "https://i.ytimg.com/vi/6ZfuNTqbHE8/maxresdefault.jpg",
    category: "Marvel",
    desc: "Marvel Studios Avengers: Infinity War In theaters April 27.",
  },
  {
    _id: "EbUHKw8r5xA&list=PLivjPDlt6ApRq22sn082ZCC9893XtV8xc",
    title: "Journey into the Deep Sea - VR | National Geographic",
    img: "https://i.ytimg.com/vi/EbUHKw8r5xA/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLDG9l35rFrbp-dWIGU-1mCsS_Ol7g",
    category: "Nat Geo",
    desc: "Set out on a virtual dive on the coral reefs of Palau with marine biologist and National Geographic Explorer Dr. Erika Woolsey as your guide. Swim with manta rays, sea turtles, and sharks while you explore beautiful and threatened coral ecosystems. ",
  },
  {
    _id: "B6uuIHpFkuo",
    title: "Purl | Pixar SparkShorts",
    img: "https://media.glamour.com/photos/5c61dd978ba0e1205e6e493f/master/pass/Dyp8cYsWoAEyG_y.jpg",
    category: "Pixar",
    desc: "Purl, directed by Kristen Lester and produced by Gillian Libbert-Duncan, features an earnest ball of yarn named Purl who gets a job in a fast-paced, high energy, bro-tastic start-up. Yarny hijinks ensue as she tries to fit in, but how far is she willing to go to get the acceptance she yearns for, and in the end, is it worth it?",
  },
  {
    _id: "58jV7lf0FAw&list=PLivjPDlt6ApRiBHpsyXWG22G8RPNZ6jlb",
    title: "Surveying The Angolan Highlands | National Geographic",
    img: "https://i.ytimg.com/vi/58jV7lf0FAw/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLCPfDi4FJtlC-eyiCeG9X57Gbhbog",
    category: "Nat Geo",
    desc: "While surveying the Angolan Highlands, scientists discovered deposits of peat that filter and feed clean water into the Okavango River Delta. For thousands of years these peatlands have been absorbing carbon dioxide from the atmosphere, but they're currently threatened by human impact. Now there's a new partnership to protect them.",
  },
  {
    _id: "QFwJJywzbDs",
    title: "Ice Age: Scrat Tales | Official Trailer | Disney+",
    img: "https://i.ytimg.com/vi/QFwJJywzbDs/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLCfFRDvmk3zuCmcdPKLLyQnA0EnUg",
    category: "Disney",
    desc: "“Ice Age: Scrat Tales” is a series of six all-new animated shorts starring Scrat, the hapless saber-toothed squirrel of the “Ice Age” adventures, who experiences the ups and downs of fatherhood, as he and the adorable, mischievous Baby Scrat, alternately bond with each other and battle for ownership of the highly treasured Acorn.",
  },
  {
    _id: "wQVUohoj1e8",
    title: "Who is the Jackal?!",
    img: "https://i.ytimg.com/vi/wQVUohoj1e8/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLA3tonXjcZLyw02ZF8VbYqYZXEc7w",
    category: "Marvel",
    desc: "Step into the Marvel Universe each Wednesday with Marvel PLAY as we bring the comics to life with unique content including character profiles, behind-the-scenes clips, cosplay tips, trailers and more! ",
  },
  {
    _id: "yRUAzGQ3nSY",
    title: "Inside Out - Official Trailer",
    img: "https://i.ytimg.com/vi/yRUAzGQ3nSY/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLArDbmv7cXeAWqR9bsKdUI7RTXJ_g",
    category: "Pixar",
    desc: "Growing up can be a bumpy road, and it's no exception for Riley, who is uprooted from her Midwest life when her father starts a new job in San Francisco. Like all of us, Riley is guided by her emotions – Joy (Amy Poehler), Fear (Bill Hader), Anger (Lewis Black), Disgust (Mindy Kaling) and Sadness (Phyllis Smith). The emotions live in Headquarters, the control center inside Riley’s mind, where they help advise her through everyday life.",
  },
  {
    _id: "KM6HWp_ik2c&list=PLivjPDlt6ApRq22sn082ZCC9893XtV8xc",
    title: "Expedition Everest: The Mission - 360 | National Geographic",
    img: "https://i.ytimg.com/vi/KM6HWp_ik2c/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLCWAshoYEkSTKRFeKi7Jm2lUFiURA",
    category: "Nat Geo",
    desc: "Immerse yourself with a team of scientists, climbers, and Sherpa guides as they embark on an expedition that will help define our understanding of high-mountain environments. Experience the National Geographic and Rolex Perpetual Planet Everest Expedition, which was not simply a climb of the mountain, but a perilous adventure to learn how climate change is impacting the highest place on Earth.",
  },
  {
    _id: "kXDmTtZxwLk",
    title: "10 Events That Changed the Marvel Universe",
    img: "https://i.ytimg.com/vi/kXDmTtZxwLk/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLC8y8ccUtGxO__CxY_sgYjr5KY2Eg",
    category: "Marvel",
    desc: "Step into the Marvel Universe each Wednesday with Marvel PLAY as we bring the comics to life with unique content including character profiles, behind-the-scenes clips, cosplay tips, trailers and more!",
  },
  {
    _id: "TyHcqX2lQWI",
    title: "Star Wars: The Clone Wars | The Phantom Apprentice Clip | Disney+",
    img: "https://lumiere-a.akamaihd.net/v1/images/anm-ff-001634_7e13ea7a.jpeg?region=361%2C253%2C2700%2C1519",
    category: "Star Wars",
    desc: "Ahsoka leads Republic clones to confront Maul’s forces on Mandalore, while Maul senses the impending chaos and makes a calculated play to ensure his own survival in “The Phantom Apprentice,” an all-new episode of Star Wars: The Clone Wars this Friday, April 24th.",
  },
  {
    _id: "0kUSV-oFxkU",
    title: "Sneak Peek! | Marvel Mech Strike: Monster Hunters",
    img: "https://i.ytimg.com/vi/0kUSV-oFxkU/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLBWPhEuzNDiSpv7dDkxnCQKM0l2dg",
    category: "Marvel",
    desc: "In this sneak peek, the Avengers suit up in their Mech Strike Monster Hunter armor, when Iron Man, Doctor Strange, and Captain Marvel discover Doctor Doom has used a mysterious magical eye to transform himself into a monster! Watch full episodes coming soon to Marvel HQ!",
  },
  {
    _id: "sN_m0GeeCTg",
    title: "Muppets Haunted Mansion | Official Trailer | Disney+",
    img: "https://i.ytimg.com/vi/sN_m0GeeCTg/hqdefault.jpg?sqp=-oaymwEbCKgBEF5IVfKriqkDDggBFQAAiEIYAXABwAEG&rs=AOn4CLCRDBWlkA7IiJ5WI7DiVYbDYQVMaQ",
    category: "Disney",
    desc: "Prepare to scream… and stream! Muppets Haunted Mansion, an Original Special, makes its spook-tacular entrance October 8 on Disney Plus.",
  },
  {
    _id: "se2Fn-y3B6A",
    title: "Land of Ice and Snow | Wild Nordic",
    img: "https://i.ytimg.com/vi/se2Fn-y3B6A/maxresdefault.jpg",
    category: "Nat Geo",
    desc: "As seen by the Viking gods, the fabled wildernesses of Norway, Finland and Sweden are revealed from the skies above.",
  },
  {
    _id: "ZlNFpri-Y40",
    title: "Ant-Man and The Wasp: Quantumania | Official Trailer",
    img: "https://i.ytimg.com/vi/ZlNFpri-Y40/maxresdefault.jpg",
    category: "Marvel",
    desc: "Watch the brand-new trailer for Marvel Studios Ant-Man and The Wasp: Quantumania",
  },
  {
    _id: "BwZs3H_UN3k",
    title: "Lightyear | Official Trailer",
    img: "https://m.media-amazon.com/images/I/811hpX9Jh0L.jpg",
    category: "Pixar",
    desc: "Every hero has a beginning. Go on an intergalactic adventure with Disney and Pixar’s Lightyear ",
  },
];
